module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table-a timelogs-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.timelogs_dataloaded), function(timelog, i) {
    return [(_vm.separate_dates && _vm.timelogListDateSpacerBoolean(_vm.timelogs, i)) ? _c('tr', {
      key: 'tf23' + i
    }, [_c('td', {
      staticClass: "timelog-date-spacer",
      attrs: {
        "colspan": "9"
      }
    })]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_c('avatar', {
      attrs: {
        "text": _vm._f("milkinitials")(timelog.user.email)
      }
    })], 1), _vm._v(" "), (false) ? _c('td', [_c('avatar', {
      attrs: {
        "input": timelog.user
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm._f("weekday1dk")(_vm.nicedate(timelog.date, 'ddd D/M-YY'))) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(timelog.hours) + " t\n            ")]), _vm._v(" "), _c('td', [(timelog.project) ? _c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/project/' + timelog.project.key
      }
    }, [_vm._v(_vm._s(timelog.project.name))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (timelog.client) ? _c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/client/' + timelog.client.key
      }
    }, [_vm._v(_vm._s(timelog.client.name))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.translateWorktype(timelog.worktype)) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(timelog.title) + "\n            ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.editTimelog(timelog)
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "linearicons/pencil"
      }
    })], 1)]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "textlink",
      on: {
        "click": function($event) {
          return _vm.delete_timelog(timelog)
        }
      }
    }, [_c('svgicon', {
      attrs: {
        "icon": "linearicons/trash"
      }
    })], 1)])])]
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Dato")]), _vm._v(" "), _c('th', [_vm._v("Tid")]), _vm._v(" "), _c('th', [_vm._v("Opgave")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Note")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-497f87d2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TimelogsList.vue
// module id = 601
// module chunks = 1